import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const TableWrapper = styled.div`
	width: 100%;
	overflow-y: auto;
	.ag-theme-balham .ag-body-viewport::-webkit-scrollbar {
		width: 8px; /* Width of the vertical scrollbar */
	}

	.ag-theme-balham .ag-body-viewport::-webkit-scrollbar-thumb {
		background-color: ${colors.grey300};
		border-radius: 10px;
	}

	.ag-theme-balham .ag-body-viewport::-webkit-scrollbar-track {
		background-color: white;
	}

	/* Horizontal scrollbar */
	.ag-theme-balham .ag-body-horizontal-scroll-viewport::-webkit-scrollbar {
		height: 8px;
	}

	.ag-theme-balham
		.ag-body-horizontal-scroll-viewport::-webkit-scrollbar-thumb {
		background-color: ${colors.grey300};
		border-radius: 10px;
	}

	.ag-theme-balham
		.ag-body-horizontal-scroll-viewport::-webkit-scrollbar-track {
		background-color: white;
	}
	
	.ag-theme-balham .ag-popup-editor {
	    border-radius: 8px;
    }
	.ag-theme-balham .ag-rich-select {
		border-radius: 8px;
	}

	.ag-theme-balham .ag-rich-select .ag-rich-select-value {
		border: 2px solid #007bff;
		border-top-right-radius: 4px;
		border-top-left-radius: 4px;
	}

	.ag-theme-balham .ag-rich-select .ag-rich-select-list {
		width: 100%;
		min-width: 120px;
		height: auto;
		max-height: 150px;
		overflow:auto
		border-radius: 4px;
		background-color: #ffffff;
	}

	.ag-theme-balham .ag-rich-select .ag-virtual-list-item {
		border-bottom: 1px solid #bdc3c759;
	}

	.ag-virtual-list-viewport {
        overflow: auto;
        width: 100%;
    }

	.ag-theme-balham {
		font-family: 'Roboto';
		.ag-root,
		.ag-side-bar,
		.ag-root-wrapper,
		.ag-status-bar {
		}

		.ag-header-row {
			border-bottom: 0px;
		}

		.ag-header {
			padding: 0px;

			.ag-icon {
				color: ${colors.grey600};
			}
		}
		.ag-header-group-cell::after {
			display: none;
		}
		.ag-header-cell-sorted-none::after {
			display: none;
		}
		.ag-header-cell {
			font-weight: bold;
			font-family: 'Roboto';
			text-transform: uppercase;
			.ag-header-cell-text {
				white-space: pre-line;
			}
			&.header-ag-black {
				.ag-icon {
					color: white;
				}
			}
			&.ag-numeric-header {
				text-align: right;
			}
		}
		.ag-header-group-cell-no-group {
			background-color: #ffffff;
			border: none;
		}
		.ag-header-group-cell-label {
			justify-content: center;
		}

		.ag-row {
			background-color: transparent;
			border-color: ${colors.grey3};

			&.ag-row-last {
				border-bottom: none;
			}
			&:hover {
				background-color: rgba(0, 255, 0, 0.12);
			}
			.ag-cell {
				font-weight: normal;
				font-size: 11px;
				color: ${colors.grey5};
			}
		}

		.ag-floating-top-viewport {
			border: none;
		}

		.ag-floating-top {
			border-color: ${colors.grey3};
		}

		.ag-row-pinned {
			border: none;

			&.ag-row-last {
				border: none;
			}

			.ag-cell {
				font-weight: bold;
			}
		}

		.ag-header-row-column {
			border-bottom: 1px solid ${colors.grey3};
		}
		.ag-row:nth-child(odd) {
			background-color: ${colors.grey100};
		}

		.ag-row:nth-child(even) {
			background-color: white;
		}
	}
`;
export const SumContainer = styled.div`
	width: 100%;
	background-color: white;
	color: ${colors.grey600};
	display: flex;
	justify-content: flex-end;
	font-size: 12px;
	font-family: Roboto;
	border: ${colors.grey300};
	padding: 3px;
	border: 1px solid ${colors.grey300};
	border-top: none;
`;
